import React, { useEffect, useState } from "react";
import { Container, Header, Divider } from "semantic-ui-react";
import { message, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../hooks";
import { institutionDashboardApi } from "../../../../api/institutionDashboardAPI";

// Componentes
import {
  KpiTotals,
  MonthlySeries,
  RolesDonut,
} from "../../../../components/Admin/InstitutionCmp";

import "./Page_InstitutionDashboard.scss";

export function Page_InstitutionDashboard() {
  const { accessToken, user } = useAuth();
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(true);
  const [overview, setOverview] = useState(null);

  // 1. Recuperar ID de la Institución.
  // En tu sistema, a veces puede estar en user.user.institutionSimulator o user.user._id.
  // Mantenemos ambos por robustez.
  const userObj = user?.user || user;
  const institutionId = userObj?.institutionSimulator || userObj?._id;

  useEffect(() => {
    let mounted = true;

    const loadData = async () => {
      if (!institutionId) return;

      try {
        setLoading(true);
        const data = await institutionDashboardApi.getOverview(
          accessToken,
          institutionId,
        );

        if (mounted) setOverview(data);
      } catch (error) {
        console.error(error);
        if (mounted) message.error(t("institution.errorLoad"));
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (institutionId) {
      loadData();
    } else {
      setLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [accessToken, institutionId, t]);

  if (!institutionId) {
    return (
      <div className="institution-dashboard-page">
        <p>{t("institution.noInstitution")}</p>
      </div>
    );
  }

  const totals = overview?.totals || {};
  const timeseries = overview?.timeseries || {};
  const roles = overview?.rolesDonut || [];

  // ✅ Spin en modo nested (tip funciona sin warnings)
  const spinning = loading && !overview;

  return (
    <div className="institution-dashboard-page">
      <Container fluid>
        <Header as="h2" className="page-title">
          {t("institution.title")}
          <Header.Subheader>{t("institution.subtitle")}</Header.Subheader>
        </Header>
        <Divider />

        <Spin
          spinning={spinning}
          size="large"
          tip={t("institution.loadingMetrics")}
        >
          <div className={spinning ? "loading-container" : "dashboard-content"}>
            {/* 1. KPIs */}
            <div className="section-block">
              <KpiTotals totals={totals} />
            </div>

            {/* 2. Gráficas */}
            <div className="section-block">
              <h3 className="section-title">
                {t("institution.monthlyEvolution")}
              </h3>
              <MonthlySeries timeseries={timeseries} loading={loading} />
            </div>

            {/* 3. Distribución */}
            <div className="section-block">
              <h3 className="section-title">{t("institution.community")}</h3>
              <div className="chart-max-width">
                <RolesDonut roles={roles} loading={loading} />
              </div>
            </div>
          </div>
        </Spin>
      </Container>
    </div>
  );
}
